module.exports = __webpack_public_path__ + "img/img_dsp.706ca56a.svg";